(function () {
  'use strict';

  angular.module('app').component('accountList', accountList());

  function accountList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowItem: '&',
      },
      controller: AccountListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/accounts/account-list/account-list.component.html',
    };
  }

  AccountListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'AccountService',
    'SystemMaintenanceService',
  ];

  function AccountListCtrl(
    config,
    UtilService,
    AbilityService,
    AccountService,
    SystemMaintenanceService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_account_superadmin'),
      canUpdate: AbilityService.can('update_account_superadmin'),
      canDestroy: AbilityService.can('destroy_account_superadmin'),
      canUpdateCountries: AbilityService.can(
        'update_countries_for_one_account_systemmaintenance_superadmin'
      ),
      canUpdateAccountSettings: AbilityService.can(
        'update_account_settings_for_one_account_systemmaintenance_superadmin'
      ),
      canUpdateRolesActions: AbilityService.can(
        'update_roles_actions_for_one_account_systemmaintenance_superadmin'
      ),
      canUpdateCompanySettings: AbilityService.can(
        'update_company_settings_for_one_account_systemmaintenance_superadmin'
      ),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = AccountService.getFilterCriteria();

    vm.subscriptionStatus = config.STATUS;
    vm.renewalOptions = config.BOOLEAN_OPTIONS;

    vm.dateDisplay = config.DATE_DISPLAY;

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    //vm.deleteItem       = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    vm.onUpdateItems = onUpdateItems;

    vm.updateCountries = updateCountries;
    vm.updateAccountSettings = updateAccountSettings;
    vm.updateRoleActions = updateRoleActions;
    vm.updateCompanySettings = updateCompanySettings;
    vm.selectCheckBoxes = selectCheckBoxes;

    function fetchResult() {
      vm.loadingItems = true;
      AccountService.getAccounts(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = AccountService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item, mode) {
      if (item.plan) {
        vm.onShowItem({ item: item, mode: mode });
      }
    }

    /*function deleteItem(item) {
            AccountService.deleteIAccount(apiUrl +'/'+ item.id, vm.onDeletedItem);
        }*/

    function changeItemStatus(item) {
      AccountService.changeAccountStatus(item);
    }

    function onUpdateItems(action) {
      var successCallback = function () {
        vm.showActions = false;
        vm.selectedAll = false;

        if (action === 'destroy') {
          fetchResult();
        }
      };

      AccountService.updateAccounts(action, vm.items, successCallback);
    }

    function updateCountries(account) {
      if (!vm.permissions.canUpdateCountries) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateCountries');
      // };

      SystemMaintenanceService.updateCountriesForOneAccount(account, {});
    }

    function updateAccountSettings(account) {
      if (!vm.permissions.canUpdateAccountSettings) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateAccountSettings');
      // };

      SystemMaintenanceService.updateAccountSettingsForOneAccount(account, {});
    }

    function updateRoleActions(account) {
      if (!vm.permissions.canUpdateRolesActions) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateRoleActions');
      // };

      SystemMaintenanceService.updateRolesActionsForOneAccount(account, {});
    }

    function updateCompanySettings(account) {
      if (!vm.permissions.canUpdateCompanySettings) {
        return;
      }

      // var successCallback = function(){
      //console.log('updateCompanySettings');
      // };

      var companies = [];
      account.companies.forEach(function (company) {
        // console.log(company); return;

        if (company.status !== 'deleted' && company.country) {
          companies.push({
            id: company.id,
            country_code: company.country.code,
            is_default: company.is_default,
          });
        }
      });

      SystemMaintenanceService.updateCompanySettingsForOneAccount(account, companies, {});
    }

    function selectCheckBoxes() {
      vm.UtilService.selectCheckBoxes();
      if (vm.selectedAll) {
        vm.totalItemsSelected = vm.meta.totalItems;
      } else {
        vm.totalItemsSelected = 0;
      }
    }
  }
})();
